import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { v4 as uuid } from 'uuid';

import { ModalSessionComponent } from './controls/modal-session/modal-session.component';
import { NavigationEnd, Router } from '@angular/router';
import { ModalCommunityComponent } from './controls/modal-community/modal-community.component';
import { AuthGuard } from './services/auth-guard.service';
import { TranslationService } from './services/translation.service';
import { TranslateService } from '@ngx-translate/core';
import { CurrencySettingsService } from './services/currency-settings.service';
import { AppBase } from './app-base';
import { GoogleAnalyticsService } from './services/google-analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  providers: [CurrencySettingsService],
})
export class AppComponent extends AppBase implements OnInit {
  @ViewChild(ModalSessionComponent) modalSession: ModalSessionComponent;
  @ViewChild(ModalCommunityComponent) modalCommunity: ModalCommunityComponent;

  title = 'app';
  public appInstanceID: string;
  public tablesTranslate: any;

  private blacklistURL = ['/auth', '/auth/reset', '/auth/restore', '/communities', '/auth/authorize'];

  constructor(
    private _translation: TranslationService,
    private _translate: TranslateService,
    private _authGuardService: AuthGuard,
    private _router: Router,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _currencySettingsService: CurrencySettingsService
  ) {
    super();
    this.appInstanceID = uuid();
  }

  ngOnInit() {
    this.initializeDatablesTranslation();
    this.subscribeEvents();
    this._googleAnalyticsService.appendTrackingCode();
    if (!this.localeSettings) {
      this.getNewLocaleSettings();
    }
  }

  shouldOpenModalSession(url: string): boolean {
    return ['/'].indexOf(url) === -1 && !this.blacklistURL.some(el => {
      return !!url.match(el);
    });
  }

  shouldOpenModalCommunity(url: string): boolean {
    const openRoutes = ['/users-admin', '/permissions-admin', '/roles-admin'];
    return !openRoutes.concat(this.blacklistURL).some(el => !!url.match(el));
  }

  checkActiveSession(url: string): void {
    if (this.shouldOpenModalSession(url)) {
      this._authGuardService.checkCurrentUserInfo(this.currentUser, url).subscribe((data) => {
        switch (data) {
          case 'currentUserNotLoggedIn':
            if (this.shouldOpenModalSession(url)) {
              this.modalSession.openModal(this.currentUser);
            }
            break;
          case 'currentCommunityHasChanged':
            if (this.shouldOpenModalCommunity(url)) {
              this.modalCommunity.openModal();
            }
            break;
        }
      });
    }
  }

  subscribeEvents(): void {
    this._router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (['/home-community'].indexOf(event.url) !== -1) {
            this.initStorage();
          }
          this.checkActiveSession(event.url);
        }
      });
  }

  initializeDatablesTranslation(): void {
    this._translation.getDataTableTranslation()
      .subscribe(dataTableTranslation => {
        this.tablesTranslate = dataTableTranslation;
      });
  }

  getNewLocaleSettings(): void {
    this._translation.getLocaleSettingsById(this.currentUser.locale_id)
      .subscribe(locale => {
        this.localeSettings = {
          symbol: locale.currencies[locale.currency_id].symbol,
          decimal_separator: locale.decimal_separator,
          thousands_separator: locale.thousands_separator,
          locale_id: locale.locale.replace('_', '-'),
          decimal_places: locale.currencies[locale.currency_id].decimal_places,
        };
        this.setLocaleSettings(this.localeSettings);
        this.customCurrencyMaskConfig = {
          align: 'rigth',
          allowNegative: true,
          prefix: locale.currencies[locale.currency_id].symbol,
          thousands: locale.thousands_separator,
          decimal: locale.decimal_separator,
          precision: locale.currencies[locale.currency_id].decimal_places,
          suffix: '',
        };
        this.setCurrencyMaskSettings(this.customCurrencyMaskConfig);
      });
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: FocusEvent): void {
    const window = event.currentTarget as Window;
    this.checkActiveSession(window.location.hash.substr(1));
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts